import { useContext, useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { notify } from 'components/common/Toast/toast.helpers';
import Table from 'components/common/Table/Table';
import TableBody from 'components/common/Table/TableBody/TableBody';
import { RootStoreContext } from 'index';
import { RoleDialogType } from 'components/roles/roles.enums';
import RoleItem from 'components/roles/RoleManagement/RoleList/RoleItem/RoleItem';
import { RoleDto } from 'components/roles/roles.dto';

import styles from './RoleList.module.scss';
import RolesSkeletonItem from './RolesSkeletonItem/RolesSkeletonItem';
import { SKELETON_ROLES_COUNT } from '../../roles.constants';

interface RoleListProps {
  onOpenDialog: (dialogType: RoleDialogType, role: RoleDto) => void;
}

const skeletonRows = Array.from(Array(SKELETON_ROLES_COUNT).keys());

const RoleList = ({ onOpenDialog }: RoleListProps) => {
  const { rolesStore } = useContext(RootStoreContext);
  const { roles, getAllRoles, isLoading } = rolesStore;

  const fetchRoles = async () => {
    try {
      await getAllRoles();
    } catch (error: any) {
      notify(error.message, 'error');
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [getAllRoles]);

  return (
    <div>
      <Table className={styles.rolesTable}>
        <TableBody>
          {isLoading
            ? skeletonRows.map((rowIndex: number) => <RolesSkeletonItem key={rowIndex} />)
            : roles.map((role) => <RoleItem key={role.id} role={role} onOpenDialog={onOpenDialog} />)}
        </TableBody>
      </Table>
    </div>
  );
};

export default observer(RoleList);
